import { useMutation, useQueryClient } from '@tanstack/react-query'
import { validatePerimeter } from '../../services/farmMapping/perimeter/validatePerimeter'
import { queryKeys } from './queryKeys'

type ValidatePerimeterVariables = Parameters<typeof validatePerimeter>[0]

export const useValidatePerimeter = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (variables: ValidatePerimeterVariables) => validatePerimeter(variables),
    // This write runs inside the caller's processLoading wrapper, which already surfaces failures
    // through the loading modal — letting the global handler fire too would double-report.
    meta: { suppressGlobalError: true },
    // The confirmation flow runs this twice (dry run, then the real write); a dry run
    // commits nothing, so refreshing after it would double every refetch. ['farms', id]
    // is not a prefix of ['farms'], so the list needs its own exact bust.
    onSuccess: (_data, variables) => {
      if (variables.dryRun) return undefined

      return Promise.all([
        queryClient.invalidateQueries({ queryKey: queryKeys.farm(variables.id) }),
        queryClient.invalidateQueries({ queryKey: queryKeys.farms(), exact: true }),
        queryClient.invalidateQueries({ queryKey: queryKeys.paddocksByIdsRoot }),
      ])
    },
  })
}
